import type { RentalManagerAddressAutocompleteWebResponseDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

const AutoCompleteAddress = ({ city = '', name = '', propertyId = '', state = '', street = '' } = {}) => ({
  city: String(city),
  name: String(name),
  propertyId: String(propertyId),
  state: String(state),
  street: String(street),
});

const AutoCompleteAddresses = ({ addresses = [] }: RentalManagerAddressAutocompleteWebResponseDto) => ({
  addresses: addresses.map((item) => AutoCompleteAddress(item)),
});

export default AutoCompleteAddresses;

export type AutoCompleteAddressesProps = ReturnType<typeof AutoCompleteAddresses>;
